export enum ProjectProductTypeFilters {
  Loan,
  CT,
  IG_greater_3,
  IG_lower_3,
}
